import { ButtonIcons } from '../../Button';

export enum TableHeadingActionType {
  primary = 'primary',
  secondary = 'secondary',
  selection = 'selection',
}

export interface TableHeadingAction {
  id?: string;
  handleOnClick: (data?: string[], areAllSelected?: boolean) => void;
  icon?: ButtonIcons;
  label?: string;
  type?: TableHeadingActionType;
}

export type TableHeadingOptions = {
  actions?: TableHeadingAction[];
  heading?: string;
};
